<template>
  <a :name="anchor"></a>
</template>
<script>
import componentState from '@/mixins/component-state'
import visibility from '@/mixins/visibility'

const baseCallbackName = 'scrollToPoint'

export default {
  props: ['name'],
  mixins: [componentState, visibility],
  data: function () {
    return {
      visibilityConfig: { toggle: true }
    }
  },
  computed: {
    callbackName: function () {
      if (this.name) {
        return `${baseCallbackName}.${this.name}`
      }
      return baseCallbackName
    },
    anchor: function () {
      return `scroll-point-${this._uid}`
    },
    hasNavBar: function () {
      return !(this.$route && this.$route.meta && this.$route.meta.hideNavbar === true)
    }
  },
  mounted: function () {
    this._register(this.callbackName, this.scrollTo)
  },
  methods: {
    scrollTo: function () {
      if (!this.isVisible) {
        const trim = this.hasNavBar ? 52 : 0
        const top = Math.max(0, this.$el.offsetTop - trim)
        const current = document.body.scrollTop || document.documentElement.scrollTop
        if (current > top) {
          window.scrollTo({ top: top, behavior: 'smooth' })
        }
      }
    }
  }
}
</script>
